var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 78"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 311",
    d: "M1.5-.002h11a1.5 1.5 0 011.5 1.5v8a1.5 1.5 0 01-1.5 1.5h-1.775L11 13.445a.5.5 0 01-.832.427l-3.194-2.874H1.5a1.5 1.5 0 01-1.5-1.5v-8a1.5 1.5 0 011.5-1.5z",
    fill: "#5f48e9"
  }))));
}

export default SvgChat;